import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import MeetingPrepBattleCard from "../troSubTabs/MeetingPrepBattleCard";
import OpportunityFilterContainer from "../../Opportunities/opportunityFilterContainer/OpportunityFilterContainer";
import GenericTable from "../../../genericComponents/genericTableComp/GenericTable";
import { useUser } from "../../../../../context/UserContext";
import  "./MeetingPrep.css"
import ScHeaderComp from "../../../genericComponents/genericTableComp/genericTableScHeader/ScHeaderComp";
// import TagOverflowHandler from "../../../uiUtils/TagOverflowHandler";
import ToggleSwitch from "../../../genericComponents/ToggleSwitch/ToggleSwitch";
import { FetchMeetingPrepsRequest } from "../../../../../store/features/actions/meetingPrep/meetingPrepsActions";
import { displayFormattedDate, getUrlDetailsObj, getUserStatsObject, recordActivity } from "../../../../../services/commonService";
import StatusIndicator from "../../../genericComponents/resizeableTable/StatusIndicator";
import BattleCard from "../../Opportunities/CardTabs/BattleCard";
import NextSteps from "../../Opportunities/CardTabs/NextSteps";
import MeetingSummaryCard from "../troSubTabs/MeetingSummaryCard";
import NextStepsMpCard from "../troSubTabs/NextStepsMpCard";
import { Button } from "react-bootstrap";
import * as FeatherIcon from "react-feather";
import iq_api_v2 from "../../../../../services/iqApiV2";
import qs from 'qs';
import PromptersCardMp from "../troSubTabs/PromptersCardMp";
import { IQ_API_V2_BASE_URL } from "../../../../../config/apiConfig";
import TR3DotMenu from "../../../genericComponents/genericTableComp/TR3DotMenu";
import { useBanner } from "../../../../../context/BannerContext";
import useAuth from "../../../../../hooks/useAuth";
import ResizableDivForTag from "../../../uiUtils/resizeobs/ResizableDivForTag";
// import ViewMeetingsModal from "../ViewMeetingsModal";

function MeetingPrep() {

  useAuth();

  const currentUrl = useLocation().pathname;
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);

  const { clientName, accountId, accountName } = useParams();
  const { user } = useUser();
  const showBanner = useBanner();

  //localStorage.removeItem("tokenData");

  //localStorage.removeItem("tokenData")
  const [isCalendarConnected, setIsCalendarDataConnected] = useState(null)
  const [outlookEmail, setOutlookEmail] = useState('')
  const [isCalendarDataLoading, setIsCalendarDataLoading] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [showExternalOnly, setShowExternalOnly] = useState(false);
  
  const location = useLocation();

  // const handleModalClose = () => {
  //     setShowModal(false);        
  // }

  const fetchOutlookToken = async (user_id) => {
    if (user_id) {
      const outlook_data = await iq_api_v2.get(`/outlook/has_valid_token?user_id=${user_id}`);
      // console.log("outlook_data?.data : ", outlook_data?.data )
      return outlook_data;
    }
  };

  useEffect(() => {
    const getOutlookToken = async () => {
      try{
        if (user?.id) {
          const outlook_data = await fetchOutlookToken(user?.id)

          const is_connected = (outlook_data?.data?.is_valid == 1) ? true : false;
          const outlook_email = outlook_data?.data?.email ? outlook_data?.data?.email : "";

          setOutlookEmail(outlook_email)
          setIsCalendarDataConnected(is_connected)
          // setIsCalendarDataLoading(true)
          setTimeout(() => {
          //  setIsCalendarDataLoading(false)
          }, 30000) // wait for 30 seconds
        }
      }catch{
        setOutlookEmail("")
        setIsCalendarDataConnected(false)
      }
    };
    getOutlookToken();
  }, [user?.id]);
  
  const handleOutlookLogin = () => {

    const pageAfterLoginUrl = window.location.href;

    const afterLoginPageParams = {clientName, accountId, accountName}
    localStorage.removeItem("afterLoginPageParams");
    localStorage.setItem("afterLoginPageParams", JSON.stringify(afterLoginPageParams));
    localStorage.setItem("pageAfterLoginUrl", pageAfterLoginUrl);

    // window.location = "https://accountiq.mnmks.com/acc_iq_api_v2_proxy/outlook/login"
    const loginWindow = window.open(
      IQ_API_V2_BASE_URL+"/outlook/login",
      "OutlookLogin",
      "width=600,height=500"
    );

    // const pollTimer = window.setInterval(() => {

    //   try {
    //     if (loginWindow.closed) {
    //       clearInterval(pollTimer);
    //       console.log("Login window closed by user or login completed.");
    //       // Optionally, refresh data or call a callback here
    //     }
  
    //     // You can also detect if it redirected to a known URL:
    //     if (
    //       loginWindow.location.href.includes("success") ||
    //       loginWindow.location.href.includes("callback") // adjust to your success URL
    //     ) {
    //       clearInterval(pollTimer);
    //       loginWindow.close();
    //       console.log("Login completed.");
    //       // Optionally, refresh data or notify parent window
    //     }
    //   } catch (e) {
    //     // Ignore cross-origin access errors until redirected to same origin
    //   }
    // }, 500);

  }

  const handleViewMeetings = () => {
    setShowModal(true);
  }

  // const fetchCalendarMeetings = async (user_id) => {

  //   const today = new Date();
  //   const yesterday = new Date();
  //   yesterday.setDate(yesterday.getDate() - 1);

  //   const dateString1 = yesterday.toISOString().split('T')[0]; // 'YYYY-MM-DD'
  //   const startDateString = displayFormattedDate(dateString1, 'DD-MM-YYYY');

  //   const next_date = new Date(today);
  //   next_date.setDate(next_date.getDate() + 7);
  //   const dateString2 = next_date.toISOString().split('T')[0]; // 'YYYY-MM-DD'
  //   const endDateString = displayFormattedDate(dateString2, 'DD-MM-YYYY');

  //   const data = {
  //     'user_id': user_id,
  //     'start_date': startDateString,
  //     'end_date': endDateString,
  //     // 'token': 'sfsaf'
  //   };
  
  //   try {

  //     const queryString = qs.stringify(data);

  //     const response = await iq_api_v2.post("/outlook/calendar/events", queryString, {
  //       headers: {
  //         'Content-Type': 'application/x-www-form-urlencoded',
  //         'Accept': 'application/json', // Matches your curl
  //       },
  //     });
  //     return response?.data || [];
  //   } catch (error) {
  //     setIsCalendarDataConnected(false);
  //     localStorage.removeItem("tokenData");
  //     console.error("Error fetching calendar meetings:", error);
  //     return [];
  //   }
  // };
  
  
  // useEffect(() => {
  //   const getCalendarData = async () => {
  //     if (user?.id) {
  //       const calendarData = await fetchCalendarMeetings(user.id);
  //       //setIsCalendarDataConnected(true)
  //       setCalendarData(calendarData?.events || [])
  //       // Do something with calendarData if needed
  //     }
  //   };
  
  //   getCalendarData();
  // }, [user?.id]);

  

  const [isOn, setIsOn] = useState(false);
  
  const [activeSwitchId, setActiveSwitchId] = useState(null);

// ✅ Define the toggle handler here — at top level
const handleActiveSwitchId = useCallback((id) => {
  setActiveSwitchId((prev) => (prev === id ? null : id));
}, []);
  const [selectedOpportunity, setSelectedOpportunity] = useState({ opportunityIds: null });
    // Tab configuration for side modal
    const commonProps = {
      opportunityIds: selectedOpportunity.opportunityIds,
      opportunityId: selectedOpportunity.opportunityId || "",
      selectedOpportunity: selectedOpportunity.opportunityInfo || {}
    };

    const randomIcon = (
      <svg xmlns="http://www.w3.org/2000/svg" className="top_tab_icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#535458" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
    );
  
    const tabConfig = [
      { key: "battle_card_mp", label: "Meeting Prep", Component: () => <MeetingPrepBattleCard {...commonProps} />, icon: randomIcon ,tagIcon:<img src="/img/blueDocIcon.png" width="16"/> },
      // { key: "metting_summary", label: "Meeting Summary", Component: () => <MeetingSummaryCard {...commonProps} />, icon: randomIcon,tagIcon:<img src="/img/blueDocIcon.svg" width="16"/>  },
      // { key: "prompters_mp", label: "Prompter", Component: () => <PromptersCardMp {...commonProps} />, icon: randomIcon,tagIcon:<img src="/img/blueDocIcon.png" width="16"/>  },
      // { key: "next_steps_mp", label: "Next Step", Component: () => <NextStepsMpCard {...commonProps} />, icon: randomIcon,tagIcon:<img src="/img/blueDocIcon.png" width="16"/>  },
    ];
    const [activeTab, setActiveTab] = useState(tabConfig?.[0]?.key);

  const dispatch = useDispatch();


  const { meetingPrepsData, meetingPrepsLoading } = useSelector(state => state?.meetingPrepsReducer);

  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [tabData, setTabData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // Search input state
  const [isMounted, setIsMounted] = useState(false);
  const [showMoreModal, setShowMoreModal] = useState(false);

  const [currRow,setCurrRow]= useState();
  // Fetch opportunities on mount
  useEffect(() => {
    setIsMounted(true);
    if (user?.id) {
      dispatch(FetchMeetingPrepsRequest({ clientName, accountName, userId: user?.id }));
    }
    return () => setIsMounted(false);
  }, [clientName, accountName, user?.id]);

    const handleCheckboxChange = (e) => {
    setShowExternalOnly(e.target.checked);

    // setFilters((prev) => ({ ...prev, is_internal : !e.target.checked }));

    // console.log('Checkbox checked:', e.target.checked);
  };

  /*
  useEffect(() => {
    const handleMessage = async (event) => {
      // Validate the origin for security
      //if (event.origin !== window.location.origin) return;
      if (event.data === 'refresh-parent') {
        const is_valid = await fetchOutlookToken(user?.id);
        setIsCalendarDataConnected(is_valid)
        showBanner({
          message: "Outlook Connected, Your meetings will start appearing here in few minutes!",
          title: "Alert",
          type: "success",
          duration: 2000,
        });
        
        setIsCalendarDataLoading(true)
        setTimeout(() => {
          dispatch(FetchMeetingPrepsRequest({ clientName, accountName, userId: user?.id }));
          setIsCalendarDataLoading(false)
        }, 30000) // wait for 30 seconds

      }
    };
  
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
  */

  useEffect(() => {
    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const handleMessage = async (event) => {
      if (event.data === 'refresh-parent') {
        const outlook_data = await fetchOutlookToken(user?.id);

        const is_connected = (outlook_data?.data?.is_valid == 1) ? true : false;
        const outlook_email = outlook_data?.data?.email ? outlook_data?.data?.email : "";
        setOutlookEmail(outlook_email)
        setIsCalendarDataConnected(is_connected);

        showBanner({
          message: "Outlook Connected, Your meetings will start appearing here in a few minutes!",
          title: "Alert",
          type: "success",
          duration: 10000,
        });

        setIsCalendarDataLoading(true);

        // Wait 30 seconds before fetching
        await delay(60000);

        // Fetch meetings and wait for completion
        await dispatch(FetchMeetingPrepsRequest({
          clientName,
          accountName,
          userId: user?.id
        }));

        setIsCalendarDataLoading(false);

        // Hide "Fetching your meetings" AFTER fetch completes
        // setTimeout(() => {
          
        // }, 90000)
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);



  const displayDateJsx = (item) => {

    var meeting_date = "";
    var meeting_time = "";
    if(item.meeting_type == "outlook"){
      meeting_date = item?.meeting_date_time || ''
      meeting_time = (item?.meta_data?.start_time || '' ) + " - " + (item?.meta_data?.end_time || '')
    }else{
      meeting_date = item?.meeting_date_time || ''
      meeting_time = (item?.meta_data?.start_time || '' ) + " - " + (item?.meta_data?.end_time || '')
    }

    return <div className="date-column">
        <div className="">
          {displayFormattedDate(meeting_date, 'DD-MMM-YYYY')}
        </div>
        <div className="sub_date">
          {meeting_time.replace(/\s/g, "")}
        </div>
      </div>
  }

  // Prepare tab content handlers
  const handleSideCard = useCallback((e, item,tabId) => {
    // console.log(item._id)
    e.preventDefault();
    e.stopPropagation();
    setShowMoreModal(true);
    setSelectedOpportunity({ opportunityIds: item?.opportunity_ids, opportunityId: item._id, opportunityInfo:item });
    setCurrRow(item);
    setActiveTab(tabId || 'battle_card_mp')
  }, []);

  // const getContactsTags = (item) => {
  //   return item.contacts.map((name) => {
  //     return <span className="opp-tag gray">{name}</span>
  //   })
  // }

  const getContactsTags = (item,idx) => {
    const tabConfig =  item.contacts.map((item)=>( {
        key:idx,
        label:item
      })
    )
    return <ResizableDivForTag handleSideCard={()=>null} items={tabConfig} rowData={{}} />
  }

  // Filter table data when filters, data or search query changes
  useEffect(() => {
    if (!meetingPrepsData) return;

    let filtered = meetingPrepsData;

    // Apply filters
    if (Object.keys(filters).length) {
      filtered = filtered.filter(item =>
        Object.entries(filters).every(([key, values]) => {
          if (!values?.length) return true;
          const itemValue = item[key.toLowerCase()] || item[key];
          return values.includes(itemValue);
        })
      );
    }

    // Apply search filter on contact_name
    if (searchQuery || showExternalOnly) {
      const query = searchQuery?.toLowerCase();

      filtered = filtered.filter(item => {
        const objective = (item.objective || '').toLowerCase();
        const contacts = Array.isArray(item.contacts) ? item.contacts.join(' ').toLowerCase() : (item.contacts || '').toLowerCase();
        const opportunities = Array.isArray(item.opportunities) ? item.opportunities.join(' ').toLowerCase() : (item.opportunities || '').toLowerCase();

        const matchesSearch = query
          ? (objective.includes(query) || contacts.includes(query) || opportunities.includes(query))
          : true;

        const matchesExternal = showExternalOnly ? item.is_internal === false : true;

        return matchesSearch && matchesExternal;
      });
    }

    const enhanced = filtered.map(item => {
      const isLoading = activeSwitchId !== null && item._id === activeSwitchId;
      // item.is_internal = false
      const baseRow = {
        ...item,
        date_and_time: displayDateJsx(item),
        organizer_name: item?.meta_data?.organizer?.name || '',
        contacts: getContactsTags(item),
        documents: (!item?.is_internal && item?.is_subscribed_account == true) ? (<ResizableDivForTag handleSideCard={handleSideCard} items={tabConfig} rowData={item} />) : ( item?.is_internal == true ? <span className="span_is_internal_meeting">This is an internal meeting</span> :  <span className="span_is_not_subscribed_account">An account not subscribed</span> ) ,
        assistant: (
          <ToggleSwitch
            meetingId={item._id}
            handleActiveSwitchId={handleActiveSwitchId}
            activeSwitchId={activeSwitchId}
          />
        ),
        saveFav: (!item?.is_internal && item?.is_subscribed_account == true) && <TR3DotMenu  menuItems={[
            { label: "Open Side Card", onMenuClick: (e) =>handleSideCard(e, item) },
          ]}/>
      };
    
      if (isLoading) {
        baseRow.isPartialLoad = (
          <>
            <td colSpan={1} className="gtr-cell-child gtr-meeting-cell-child">
              <span>{displayFormattedDate(new Date().toISOString().split('T')[0])}</span>
            </td>
            <td
              colSpan={3}
              className="gtr-cell-child gtr-meeting-cell-child"
              onClick={(e) => handleSideCard(e, item, "increase_deal_size")}
            >
              <StatusIndicator text="Listening meeting in progress" indicator_type="voice" />
            </td>
            <td colSpan={1} className="gtr-cell-child gtr-meeting-cell-child">
              <div onClick={(e) => {
                e.preventDefault();
                setActiveSwitchId(null); // Will now correctly trigger re-render
              }}>
                <ToggleSwitch
            meetingId={item._id}
            handleActiveSwitchId={handleActiveSwitchId}
            activeSwitchId={activeSwitchId}
          />
              </div>
            </td>
            <td colSpan={1} className="gtr-cell-child gtr-meeting-cell-child">
              <TR3DotMenu  menuItems={[
            { label: "Open Side Card", onMenuClick: (e) =>handleSideCard(e, item) },
          ]} />
            </td>
          </>
        );
      }
    
      return baseRow;
    });
    

    setTabData(enhanced);
  }, [meetingPrepsData, filters, searchQuery, showExternalOnly, handleSideCard, activeSwitchId]);

  // Extract unique values to generate filter options
  useEffect(() => {
    if (!meetingPrepsData?.length) return;

    const include = ['location'];
    const optionMap = {};

    meetingPrepsData.forEach(item => {
      Object.entries(item).forEach(([key, value]) => {
        if (include.includes(key)) {
          optionMap[key] = optionMap[key] || new Set();
          optionMap[key].add(value);
        }
      });
    });

    const formatted = Object.entries(optionMap).reduce((acc, [key, set]) => {
      acc[key] = [...set];
      return acc;
    }, {});

    setFilterOptions(formatted);
  }, [meetingPrepsData]);

  // Columns for GenericTable
  const tableColumns = [
    { id: "date_and_time", label: "Date & Time", width: 100,alignment:"center" },
    { id: "objective", label: "Subject", width: 150 },
    { id: "organizer_name", label: "Organizer", width: 100 ,alignment:"center"},
    { id: "contacts", label: "Attendees", width: 200 ,alignment:"center"},
    //{ id: "opportunities", label: "Opportunity", width: 200 },
    { id:"documents" ,label:"Documents", width:150,alignment:"center"},
    //{ id:"assistant" ,label:"Assistant", width:80},
    { id: "saveFav", label: "", width: 50, clickAction: true },
  ];


  useEffect(() => {
    if(user?.id){
      let userStat = getUserStatsObject(
        'Meeting Prep',
        "meeting_prep",
        "Page Source: Meeting Prep",
        currentUrl,
        ''
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    }
  }, [user?.id])

  return (
    <>
      {/* <OpportunityFilterContainer
        filterOptions={filterOptions}
        filters={filters}
        setFilters={setFilters}
        type={"spot"}
        mainTitl={"Walk into meetings fully prepped — in minutes."}
        filterTitl={"Pick Contact"}
        oppBtnTitl={"Or Generate Meeting Prep for your Upcoming meeting"}
        disableFilter={true}
        chatbotBtnTxt="Add Meeting"
        parentTab={"mp"}
        container_class="meeting_prep-filter-container"
      /> */}

      <div className={`find-opportunities-container ${isMounted ? "mounted" : ""}`}>
      
      {/* {alert("isCalendarDataLoading  : "+ isCalendarDataLoading + " isCalendarConnected : "+ isCalendarConnected)} */}
        {((isCalendarDataLoading == true && isCalendarConnected == true)) && <div className="col-md-12 connect_calendar_card mb-3 mt-2">
          <div className="row">
                <div className="col-md-7">                    
                  <div className="connect_calendar_block"> 
                      <div className="connect_calendar_icon">
                        <FeatherIcon.Mail className="calendar_fa"/>
                      </div> 
                      <div className="connect_para_block">
                          <p className="connect_calendar_head">Connected to calendar </p>
                          <p className="connect_para">Outlook Connected, Your meetings will start appearing here in few minutes</p>
                      </div>
                  </div>                   
                </div>
                <div className="col-md-5">
                  <span className="connect_calendar_btnblock">
                    <Button variant="primary" type="submit" className="pull-right connect_calendar_btn" disabled > <i className="fa fa-spinner fa-spin"></i> Fetching your meetings </Button>
                  </span>
                </div>
          </div>                
        </div>
        }

        {isCalendarConnected === false && <div className="col-md-12 connect_calendar_card mb-3 mt-2">
          <div className="row">
                <div className="col-md-6">                    
                  <div className="connect_calendar_block"> 
                      <div className="connect_calendar_icon">
                        <FeatherIcon.Mail className="calendar_fa"/>
                      </div> 
                      <div className="connect_para_block">
                          <p className="connect_calendar_head">Connect your calendar </p>
                          <p className="connect_para">Connect with your Outlook to automate meeting prep</p>
                      </div>
                  </div>                   
                </div>
                <div className="col-md-6">
                  <span className="connect_calendar_btnblock">
                    <Button variant="primary" type="submit" className="pull-right connect_calendar_btn" onClick={() => handleOutlookLogin()} > Connect your calendar </Button>
                  </span>
                </div>
          </div>                
        </div>
        }

        {outlookEmail && <div className="row mb-2">
          <div className="col-md-12 text-right align-right">
            <span className="font13" style={{
              fontWeight: '600'
            }}> Connected Email:  </span> <span className="font13 green mr-3">{outlookEmail}</span>  
          </div>
        </div>
        }

        <span style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom:'10px'}}>
          <h6 className="find-opportunities-results-title">
            Showing {tabData?.length || 0} Results  
          </h6>

          {Object.entries(filters).reduce((sum, [key, value]) => sum + (value?.length || 0), 0) > 0 && (
            <div className="find-opportunities-results-title-filter-badge">
              {Object.entries(filters).reduce((sum, [key, value]) => sum + (value?.length || 0), 0)} filters applied 
              <img src="/img/x.png" onClick={() => setFilters({})} />
            </div>
          )}

          <div className="d-flex">
            <span className="d-flex align-items-center justify-content-center mr-2">
              <input 
                id="chk_show_external_meetings_only"
                type="checkbox" 
                className="me-1"
                checked={showExternalOnly}
                onChange={handleCheckboxChange}
              /> <label className="font13 mb-0 mt-1 cursorP" htmlFor="chk_show_external_meetings_only"> External meetings only </label> 
            </span>

            <span className="spot-contacts-search-input-container">
              
              <img src="/img/search.png"  className="spot-contacts-search-icon"/>
              <input
                  type="text"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="spot-contacts-search-input"
              />
          </span>

          </div>
          
        </span>

        <div className="find-opportunities-results-container">
          <GenericTable
          disableSort={true}
          loading={meetingPrepsLoading}
            initialColumns={tableColumns}
            tabData={tabData}
            sideCardTabConfig={tabConfig}
            showMoreModal={showMoreModal}
            setShowMoreModal={setShowMoreModal}
            oppName={""}
            titleForSideCard={
              <ScHeaderComp 
                key={`side_card_head_comp_${commonProps?.opportunityId}`} 
                type="meeting_prep" 
                opportunityId={commonProps?.opportunityId} 
                data={currRow} 
                titlkey={"objective"} 
                titlTxt="" 
                setShowMoreModal={setShowMoreModal} 
                activeTab={activeTab}
              />}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            activeSwitchId={activeSwitchId}
          />
        </div>

        {/* <ViewMeetingsModal
          show={showModal}
          onClose={handleModalClose}
          calendarData={calendarData}
        /> */}

      </div>
    </>
  );
}

export default MeetingPrep;
